import siteConfig from './site-config.json'
import * as logger from '../abt-utils/logger'
import * as qa from './qa'
import { getDefault } from '../abt-utils/structure'

/**
 * Gets available test modules using wepack's require.context.
 * @returns {array} Returns the array of resolved test modules.
 */
export function get () {
  var contextRequire = require.context('../abt-tests', true, /abt\d+\/test\.js$/)
  return contextRequire.keys().map(contextRequire).map(getDefault)
}

/**
 * Exposes test modules as a global variable when the user is in qa or dev mode.
 * @param {array} tests - The array of test configs to expose.
 */
export function expose (tests) {
  if (!logger.isVerbose() && !qa.enabled()) return
  window[siteConfig.testData] = tests
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-core/abtest-modules.js
 ** module id = 42
 ** module chunks = 2
 **/